import React, { ReactNode, CSSProperties } from 'react';
import { styles } from './ContentBlock.css';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';
import { atoms, Atoms } from '../styles/atoms.css';

export type ContentBlockStyleProps = {
  maxWidth?: Atoms['maxWidth'];
  paddingX?: Atoms['paddingX'];
  paddingLeft?: Atoms['paddingLeft'];
  paddingRight?: Atoms['paddingRight'];
  paddingY?: Atoms['paddingY'];
  paddingTop?: Atoms['paddingTop'];
  paddingBottom?: Atoms['paddingBottom'];
  backgroundColor?: Atoms['backgroundColor'];
};

export type ContentBlockProps = {
  children: ReactNode;
  className?: string;
  style?: Pick<CSSProperties, 'backgroundColor' | 'color' | 'marginTop'>;
} & ContentBlockStyleProps;

export const DEFAULT_CONTENT_BLOCK_PADDING_X = {
  mobile: 'large',
  tablet: 'xlarge',
  desktop: 'xlarge',
};

export const ContentBlock = ({
  maxWidth = 'large',
  paddingX = DEFAULT_CONTENT_BLOCK_PADDING_X as Atoms['paddingX'],
  paddingY,
  paddingLeft,
  paddingRight,
  paddingTop,
  paddingBottom,
  backgroundColor,
  className,
  style,
  children,
}: ContentBlockProps) => {
  const containerStyles = atoms({
    backgroundColor,
  });

  const _paddingX = paddingLeft || paddingRight ? undefined : paddingX;

  const bodyStyles = atoms({
    paddingX: _paddingX,
    paddingLeft,
    paddingRight,
    paddingY,
    paddingTop,
    paddingBottom,
    maxWidth,
  });

  return (
    <div style={style} className={classNames(containerStyles, styles.container)}>
      <div className={classNames([styles.content, bodyStyles, className])}>{children}</div>
    </div>
  );
};
